var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"position":"relative","height":"60vh","width":"100%"}},[_c('BarChart',{attrs:{"options":{
            responsive: true,
            plugins: {
                tooltip: {
                    callbacks: {
                        beforeLabel: function(tooltipItem) {
                            let data = _vm.chartDataFinal
                            return data[tooltipItem.dataIndex].competence // Customizar label do tooltip
                        }
                    }
                }
            }
        },"data":{
            labels: _vm.chartDataFinal.map((row, index) => index + 1),
            datasets:[
                {   
                    fill: 'origin',
                    label: 'Competencias',
                    backgroundColor: '#3866af',
                    borderColor: '#3866af',
                    data: _vm.chartDataFinal.map(row => row.note),
                    tension: 0.1
                }
            ]
        }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }